$('.search-music-results').on('click', 'a.link-collapse', 'click', function () {
  if ($(this).find('span.title-collapse').html() == 'Hide more versions') {
    $(this).find('img').attr('src', '/images/arrow-bottom-01.png');
    $(this).find('span.title-collapse').html('View more versions');
  } else {
    $(this).find('img').attr('src', '/images/arrow-top-01.png');
    $(this).find('span.title-collapse').text('Hide more versions');
  }
});
